import { Divider, DividerProps } from '@healthinal/ui';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ForwardRefExoticComponent, RefObject } from 'react';

interface MotionDividerProps {
  contentSectionRef: RefObject<HTMLElement | null>;
  inputRange?: number[];
  outputRange?: number[];
}

const MotionDividerComponent = motion.create<Omit<DividerProps, 'style'>>(
  Divider as ForwardRefExoticComponent<DividerProps>,
);

export function MotionDivider({ contentSectionRef, inputRange = [0, 25], outputRange = [0, 1] }: MotionDividerProps) {
  const { scrollY } = useScroll({ container: contentSectionRef, layoutEffect: false });
  const dividerOpacity = useTransform(scrollY, inputRange, outputRange, { clamp: true }); // slowly fade divider in as user scrolls down
  return <MotionDividerComponent style={{ opacity: dividerOpacity }} />;
}
